// import logo from './logo.svg';
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import lozad from "lozad";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Faq } from "./pages/Faq";
import { CustomerService } from "./pages/CustomerService";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { ShopMen } from "./pages/ShopMen";
import { ShopWomen } from "./pages/ShopWomen";
import { Home } from "./Home";
import { Footer } from "./include/Footer";
import { Header } from "./include/Header";
import { animateScroll as scroll } from "react-scroll";

function App() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <div className="App">
      <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/customerservice" element={<CustomerService />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/shopmen" element={<ShopMen />} />
          <Route path="/shopwomen" element={<ShopWomen />} />
        </Routes>
     
      <Footer />
    </div>
  );
}

export default App;
